import { t } from "i18next";
import { permissions, routes } from "../../config";
import { formatDate } from "../../utils";
import { isAllowedToView } from "utils/AuthUtils";

export const QUESTIONNAIRE_TYPES = Object.freeze({
  GHG_EMISSIONS: "GHG_EMISSIONS",
  PHYSICAL_RISK: "PHYSICAL_RISK",
  DECARBONIZATION_NET_ZERO_PLAN: "DECARBONIZATION_NET_ZERO_PLAN",
});

export const mapSupplierQuestionnairesData = (questionnaires, currentUser) => {
  if (questionnaires && questionnaires.length > 0) {
    const currentUserQuestionnaires = questionnaires.filter(
      (q) => q.assignee?.toLowerCase() === currentUser?.sub?.toLowerCase()
    );

    return currentUserQuestionnaires
      .concat(questionnaires.filter((q) => q.assignee?.toLowerCase() !== currentUser?.sub?.toLowerCase()))
      .map((questionnaire) => {
        const isAssignedToCurrentUser = questionnaire.assignee?.toLowerCase() === currentUser?.sub?.toLowerCase();

        return {
          id: questionnaire.id,
          assigneeName: questionnaire.assigneeName ?? "",
          period: questionnaire.period ? `${questionnaire.period.year} ${questionnaire.period.quarter}` : "",
          type: questionnaire.type,
          mappedType: questionnaire.type ? t(`supplierQuestionnaires.questionnaireTypes.${questionnaire.type}`) : "",
          status: questionnaire.status,
          mappedStatus: questionnaire.status ? t(`questionnaireStatus.${questionnaire.status}`) : "",
          // TODO use Date() or an ISO-standard string instead of a custom format
          endDate: formatDate(questionnaire?.endDate ?? null, false),
          rowCustomStyles: {
            backgroundColor: !isAssignedToCurrentUser ? "#f1f1f1" : null,
          },
          isAssignedToCurrentUser,
        };
      });
  }

  return [];
};

export const getSupplierQuestionnairesRoute = (userPermissions) => {
  return isAllowedToView(userPermissions, permissions.supplierPortalDataEntryPlanning)
    ? routes.supplierPortalDataEntryPlanning
    : routes.supplierQuestionnaires;
};
